<template>
  <div class="ratio ratio-16x9" v-if="component.video" ref="player">
    <div
      class="d-flex justify-content-center align-items-center w-100 h-100"
      v-if="!ready"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player'
export default {
  props: ['component'],
  data() {
    return {
      player: null,
      ready: false,
    }
  },
  mounted() {
    if (this.component.video) {
      this.player = new Player(this.$refs.player, {
        id: this.component.video.split('/').pop(),
      })
      this.player.ready().then(() => {
        this.ready = true
      })
      .catch(error => {
        console.error(error)
      })
      this.player.on('ended', this.ended)
    }
  },
  methods: {
    play() {
      if (this.ready) {
        this.player.play()
      } else {
        this.player.ready().then(() => {
          this.player.play()
        })
      }
    },
    ended(event) {
      this.$emit('videoEnded', { event, component_id: this.component.id })
    },
  },
}
</script>